<template>
    <a @click.prevent="openCart" :href="cartUrl" target="_blank" rel="nofollow" class="btn btn-lg btn-block btn-primary border-2 rounded-full font-semibold text-xl">
        <i class="fad fa-shopping-cart fa-lg mr-2"></i>
        <span>Add to Cart</span>
    </a>
</template>

<script>
import ListingMixin from '../../mixins/listing';

export default {
    mixins: [ListingMixin],

    props: ['listing'],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
